/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthOtpResponse as ModelsAuthenticationAuthOtpResponse } from '../../models/Models/Authentication/auth-otp-response';

export interface V4CustomersMeDetailsOtpGet$Json$Params {
  mobile?: string;
  email?: string;
}

export function v4CustomersMeDetailsOtpGet$Json(http: HttpClient, rootUrl: string, params?: V4CustomersMeDetailsOtpGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeDetailsOtpGet$Json.PATH, 'get');
  if (params) {
    rb.query('mobile', params.mobile, {});
    rb.query('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>;
    })
  );
}

v4CustomersMeDetailsOtpGet$Json.PATH = '/v4/customers/me/details-otp';
